// src/VitalsTimer.js

export class VitalsTimer {
  constructor(uiElements, audio, notify, onTimeout) {
    this.ui = uiElements;
    this.audio = audio;
    this.notify = notify;
    this.onTimeout = onTimeout;
    this.state = {
      intervalId: null,
      endTime: null,
      active: false
    };
  }

  clear() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
    this.state.intervalId = null;
    this.state.endTime = null;
    this.state.active = false;
    
    if (this.audio && this.audio.stopMonitor) {
      this.audio.stopMonitor();
    }
    
    if (this.ui.vitalsFill) this.ui.vitalsFill.style.width = '100%';
    if (this.ui.vitalsTimer) this.ui.vitalsTimer.textContent = '--';
  }

  addTime(seconds) {
    if (this.state.active && this.state.endTime) {
      this.state.endTime += (seconds * 1000);
      
      const newRemaining = this.state.endTime - Date.now();
      if (newRemaining > this.state.limitMs) {
          this.state.limitMs = newRemaining;
      }
    }
  }

  start(passiveSystem, economy, session, modifiers, node) {
    this.clear();
    const baseMs = 45000;

    let limitMs = passiveSystem ? passiveSystem.applyTimeBuffer(baseMs) : baseMs;

    const classDef = economy.rpg.getClassDef();
    if (classDef) {
      if (classDef.passive && classDef.passive.type === 'time_buffer') {
        limitMs += (classDef.passive.value * 1000);
      }
      if (classDef.sesgo && classDef.sesgo.type === 'time_penalty') {
        limitMs += (classDef.sesgo.value * 1000);
      }
    }

    // Apply tag time multipliers from Perks (e.g. farmacopea_bolsillo)
    if (modifiers && modifiers.time && modifiers.time.tagMultipliers && node) {
      const nodeTags = (node.tags || []).map(t => t.toLowerCase());
      if (node.topic) nodeTags.push(node.topic.toLowerCase());
      if (node.tema) nodeTags.push(node.tema.toLowerCase());
      
      nodeTags.forEach(tag => {
        if (modifiers.time.tagMultipliers[tag]) {
          limitMs = Math.round(limitMs * modifiers.time.tagMultipliers[tag]);
        }
      });
    }

    const burnoutPenalty = (economy.burnout || 0) * 50; 
    
    // Nueva penalización por estabilidad: Inestabilidad = menos tiempo para pensar
    let stabilityPenalty = 0;
    if (session && session.patientState) {
        const est = session.patientState.estabilidad;
        if (est < 80) stabilityPenalty = (80 - est) * 60; // Hasta 4.8s de penalización si estabilidad es 0 (suavizado)
    }

    limitMs = Math.max(6000, limitMs - burnoutPenalty - stabilityPenalty);

    this.state.limitMs = limitMs; // Store limitMs for checking fast answers
    this.state.endTime = Date.now() + limitMs;
    this.state.active = true;

    const tick = () => {
      if (!this.state.active || !this.state.endTime) return;
      
      const now = Date.now();
      const remaining = this.state.endTime - now;
      const clamped = Math.max(0, remaining);
      const ratio = limitMs === 0 ? 0 : clamped / limitMs;
      
      if (this.ui.vitalsFill) this.ui.vitalsFill.style.width = `${ratio * 100}%`;
      if (this.ui.vitalsTimer) this.ui.vitalsTimer.textContent = Math.ceil(clamped / 1000).toString();
      
      // Elite Visual & Audio Polish: Clinical Pressure [cite: 1, 9]
      const est = session?.patientState?.estabilidad || 100;
      const isCritical = est < 40 || clamped <= 5000;
      const bpm = clamped <= 5000 ? 120 : (80 + (100 - est) / 2);

      // Start/Update Monitor Audio
      if (this.audio.startMonitor) {
          if (!this.state.lastMonitorBpm || Math.abs(this.state.lastMonitorBpm - bpm) > 5 || this.state.lastCritical !== isCritical) {
              this.audio.startMonitor(bpm, isCritical);
              this.state.lastMonitorBpm = bpm;
              this.state.lastCritical = isCritical;
          }
      }

      if (clamped <= 5000 && clamped > 0) {
        if (this.ui.vitalsFill) this.ui.vitalsFill.classList.add('danger-pulse');
        if (this.ui.vitalsTimer) this.ui.vitalsTimer.classList.add('danger-pulse');
      } else {
        if (this.ui.vitalsFill) this.ui.vitalsFill.classList.remove('danger-pulse');
        if (this.ui.vitalsTimer) this.ui.vitalsTimer.classList.remove('danger-pulse');
      }

      if (clamped <= 0) {
        this.clear();
        if (this.audio.playFlatline) this.audio.playFlatline();
        else this.audio.playFailure();
        
        this.notify('⏱️ Tiempo agotado. El paciente se descompensó.', 'error');
        if (this.onTimeout) this.onTimeout();
      }
    };

    tick();
    this.state.intervalId = setInterval(tick, 200);
  }
}
